module.exports = {
  footerText: 'Copyright American Chase © 2025',
};
